import React from "react";
import {
  FooterFacebookIcon,
  FooterInstagramIcon,
  FooterLinkedInIcon,
  FooterYoutubeIcon,
  FooterTwitterIcon,
} from "./Icons";
import FooterTopWave from "../../assets/img/footer/FooterTopWave.webp";
const Footer = () => {
  return (
    <>
      <div className="w-100 FromTopWave">
        <img className="w-100" src={FooterTopWave} alt="" />
      </div>
      <div className="footer-section   margin-top-minus-footer  open_overlay_sections_none">
        <div className="container">
          <div className="d-flex align-items-center mb-4 mb-lg-5 ">
            <a href="https://www.instagram.com/?hl=en" target="_blank">
              <FooterInstagramIcon />
            </a>{" "}
            <a href="https://twitter.com/home" target="_blank">
              <FooterTwitterIcon />
            </a>
            <a href="https://www.linkedin.com/feed/" target="_blank">
              <FooterLinkedInIcon />
            </a>{" "}
            <a href="https://www.facebook.com/" target="_blank">
              <FooterFacebookIcon />
            </a>
            <a href="https://youtube.com/" target="_blank">
              <FooterYoutubeIcon />
            </a>
          </div>
          <div className="row justify-content-between">
            <div className="col-6 col-lg-auto mb-4">
              <div>
                <h4 className="font-lg fw-semibold mb-3 white">Company</h4>
                <ul className="list-unstyled">
                  <li>
                    <a
                      href="#About"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Team"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Team
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Privacy"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Pitch Deck
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-6 col-lg-auto mb-4">
              <div>
                <h4 className="font-lg fw-semibold mb-3 white">Services</h4>
                <ul className="list-unstyled">
                  <li>
                    <a
                      href="#Solution"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Solution Design
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Global"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Global Technologies
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Security"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Security
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Managed Support
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Legacy"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Legacy Modernization
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Quality"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Quality and Performance Engineering
                    </a>
                  </li>
                </ul>
              </div>
            </div>{" "}
            <div className="col-6 col-lg-auto mb-4">
              <div>
                <h4 className="font-lg fw-semibold mb-3 white">Advanced</h4>
                <ul className="list-unstyled">
                  <li>
                    <a
                      href="#"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Al and Ml
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Cloud"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Cloud
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Blockchain"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Blockchain
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Data"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Data, Ai and Analytics
                    </a>
                  </li>
                  <li>
                    <a
                      href="#DevOps"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      DevOps
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Data"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Lot
                    </a>
                  </li>
                </ul>
              </div>
            </div>{" "}
            <div className="col-6 col-lg-auto mb-4">
              <div>
                <h4 className="font-lg fw-semibold mb-3 white">Industries</h4>
                <ul className="list-unstyled">
                  <li>
                    <a
                      href="#Finance "
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Finance
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Tavel"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Tavel , Transportation & Hospitality
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Media"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Media & Life Sciences
                    </a>
                  </li>
                  <li>
                    <a
                      href="#Retail"
                      className="text-decoration-none font-normal opacity_07 white hoverline mb-2"
                    >
                      Retail & Distibution
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <span className="footer-line d-inline-block mt-5"></span>
        <div className="copyright_text opacity_07">
          <p className="fw-normal font-normal white  text-center mb-0 py-3  ">
            © Global Technologies
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
